import { getColumnsList } from '@/features/AudienceManager/services';
export const fetchExportationColumns = () => {
    return getColumnsList()
        .then(response => formatValue(response?.data))
        .catch(error => {
        console.error('Failed to fetch exportation columns:', error);
        return formatValue(undefined);
    });
};
const formatValue = (response) => {
    return {
        columns: Object.values(response?.data?.columns ?? {}).filter(column => column.key !== 'pmweb_id'),
        groups: response?.data?.groups || [],
        success: response?.success,
    };
};
